const searchModule =
    searchModule ||
    (() => {
        let timer = null
        let previousXhr = null
        let suggestionUrl = ""
        let resultUrl = ""
        let resultQuerystringKey = ""

        const classNamePrefix = "search-page"

        const debounce = (delay, callback, args) => {
            if (timer) {
                clearTimeout(timer)
                // console.log("cancel previous call")
            }
            timer = setTimeout(() => {
                timer = null
                callback(args)
            }, delay)
        }

        const callback = (value) => {
            xhrCall(value)
        }

        const xhrCall = (value) => {
            if (previousXhr) {
                // console.log("current xhr abort")
                previousXhr.abort()
            }
            const xhr = new XMLHttpRequest()
            previousXhr = xhr
            xhr.open("get", `${suggestionUrl}${encodeURIComponent(value)}`, true)
            xhr.onload = (e) => {
                try {
                    const resultText = e.target.response
                    const result = JSON.parse(resultText)
                    if (result.status === "ok") {
                        const hits = result.hits
                        const html = hits.reduce((acc, current) => {
                            return (
                                acc +
                                `
                                <a class="search-page__suggestion-entry" href="${resultUrl}?${resultQuerystringKey}=${encodeURIComponent(
                                    current.query
                                )}">${current.query}</a>
                            `
                            )
                        }, "")
                        renderSuggestions(html)
                    }
                } catch (e) {
                    console.log("Exception in XHR call")
                } finally {
                    previousXhr = null
                }
            }
            xhr.send()
        }

        const inputHandler = (e) => {
            if (e.target.value === "") {
                if (previousXhr) previousXhr.abort()
                if (timer) clearTimeout(timer)
                renderSuggestions("")
                return
            }
            debounce(300, callback, e.target.value)
        }

        const keyupHandler = (e) => {
            if (e.keyCode === 13 && e.target.value.length > 0) {
                doSearch(e.target.value)
            }
        }

        const searchIconClickHandler = (e) => {
            const input = document.querySelector(`.${classNamePrefix}__textbox`)
            if (input && input.value.length > 0) {
                doSearch(input.value)
            }
        }

        const doSearch = (searchText) => {
            window.location.href = `${resultUrl}?${resultQuerystringKey}=${encodeURIComponent(searchText)}`
        }

        const clearButtonClickHandler = () => {
            if (previousXhr) previousXhr.abort()
            if (timer) clearTimeout(timer)
            clearTextbox()
            renderSuggestions("")
        }

        const clearTextbox = () => {
            const input = document.querySelector(`.${classNamePrefix}__textbox`)
            if (input) input.value = ""
        }

        const renderSuggestions = (innerHTML) => {
            const suggestionsContainer = document.querySelector(`.${classNamePrefix}__suggestions-container`)
            if (suggestionsContainer) suggestionsContainer.innerHTML = innerHTML
        }

        const init = () => {
            const input = document.querySelector(`.${classNamePrefix}__textbox`)
            if (input) {
                input.addEventListener("input", inputHandler)
                input.addEventListener("keyup", keyupHandler)
            }
            const clearButton = document.querySelector(`.${classNamePrefix}__clear`)
            if (clearButton) clearButton.addEventListener("click", clearButtonClickHandler)

            const inputBlock = document.querySelector(`.${classNamePrefix}__input`)
            if (inputBlock) {
                suggestionUrl = inputBlock.dataset.suggestionUrl
                resultUrl = inputBlock.dataset.resultUrl
                resultQuerystringKey = inputBlock.dataset.resultQuerystringKey
            }

            const searchIcon = document.querySelector(`.${classNamePrefix}__icon`)
            if (searchIcon) {
                searchIcon.addEventListener("click", searchIconClickHandler)
            }
        }

        return {
            init,
        }
    })()

window.addEventListener("DOMContentLoaded", searchModule.init)
